module.exports = __webpack_public_path__ + "img/moses-rogers.4aa66cc9.png";